<template>
    <div>
        <!-- Modal -->
        <div class="modal fade" id="interestModal" tabindex="-1" role="dialog" aria-labelledby="interestModalLabel" aria-hidden="true">
            <div class="modal-dialog" v-bind:class="position === 'desktop' ? 'desktop' : 'mobile'" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title" id="interestModalLabel">Apa yang kamu minati ? Silahkan Pilih minimal 3</h5>
<!--                        <button type="button" class="close" data-dismiss="modal" aria-label="Close" v-if="selected.length > 2">-->
<!--                            <span aria-hidden="true">&times;</span>-->
<!--                        </button>-->
                    </div>
                    <div class="modal-body">
                        <div class="text-center" v-if="loading">
                            <pulse-loader color="#EC550E"></pulse-loader>
                        </div>
                        <div v-else>
                            <div class="interest-wrap">
                                <span v-for="item in interests" :key="item._id" class="interest-item" v-bind:class="item.selected === true ? 'selected' : ''" @click="selectItem(item)">{{ item.name }}</span>
                            </div>
                            <div class="text-center text-danger" v-if="errors.hasOwnProperty('interests')">
                                {{ errors['interests'][0] }}
                            </div>
                        </div>
                    </div>
                    <div class="modal-footer">
<!--                        <button type="button" class="btn btn-secondary" data-dismiss="modal" :disabled="selected.length < 3">Tutup</button>-->
                        <button type="button" class="btn btn-primary" @click="handleSubmit" :disabled="selected.length < 3">Selesai</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import $ from "jquery";
import axios from "axios";
import _ from "lodash"
import moment from "moment";
import PulseLoader from 'vue-spinner/src/PulseLoader.vue'

export default {
    name: "Interest",
    props: ['position'],
    components: {
        PulseLoader
    },
    data() {
        return {
            interests: [],
            selected: [],
            errors: [],
            loading: true
        }
    },
    async mounted() {
        this.getUser()
    },
    methods: {
        async getUser() {
            const token = this.$cookies.get('token');
            await axios.get('/api/user', { headers: {"Authorization" : `Bearer ${token}`} })
                .then((response) => {
                    // this.user = response.data
                    if(response.data.interests.length < 2) {
                        $(`#interestModal`).modal({
                            backdrop: 'static',
                            keyboard: false
                        });
                        this.getInterest()
                        this.$emit('show', false)
                    } else {
                        this.$emit('show', true)
                    }
                })
                .catch((error) => {

                });
        },
        async getInterest() {
            const token = this.$cookies.get('token');
            await axios.get(`/api/interest`, { headers: {"Authorization" : `Bearer ${token}`} })
                .then((response) => {
                    this.interests = response.data
                    this.loading = false
                })
                .catch((error) => {

                });
        },
        handleSubmit () {
            const token = this.$cookies.get('token');
            this.errors = [];
            this.loading = true;
            axios.post('/api/interest', {interests: this.selected}, { headers: {"Authorization" : `Bearer ${token}`} })
                .then((response) => {
                    this.$notify({
                        duration: 5000,
                        group: 'main',
                        title: 'Berhasil!',
                        text: response.data.message,
                        type: 'success'
                    })
                    $(`#interestModal`).modal('hide');
                    this.$emit('show', true)
                })
                .catch((error) => {
                    if(error.response) {
                        this.$notify({
                            duration: 5000,
                            group: 'main',
                            title: 'Oopppss!',
                            text: error.response.data.message,
                            type: 'warn'
                        })
                        if(error.response.status === 422) {
                            this.errors = error.response.data.errors
                            window.scrollTo(0,0);
                        }
                    }
                    this.loading = false;
                    // Reset recaptcha for load new
                    // this.$refs.recaptcha.reset();
                });
        },
        selectItem(item) {
            const check = _.find(this.selected, { '_id': item._id });
            var newInterest = this.interests;
            var index = _.findIndex(this.interests, { '_id': item._id });
            if(!check) {
                newInterest.splice(index, 1, {...item, ...{selected: true}});
                this.interests = newInterest

                this.interests.find(el => el._id === item._id).selected = true
                this.selected.push(item);
            } else {
                newInterest.splice(index, 1, {...item, ...{selected: false}});
                this.interests = newInterest

                this.selected = _.remove(this.selected, function (selected) {
                    return selected._id === item.id;
                })
            }
        }
    }
}
</script>

<style scoped>
#interestModal {
    background: rgb(0 0 0 / 40%);
}
.interest-wrap {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    justify-content: center;
}
.interest-item {
    background: #969696;
    padding: 4px 8px;
    margin: 6px;
    border-radius: 5px;
    color: #fff;
    cursor: pointer;
    -webkit-touch-callout: none; /* iOS Safari */
    -webkit-user-select: none; /* Safari */
    -khtml-user-select: none; /* Konqueror HTML */
    -moz-user-select: none; /* Old versions of Firefox */
    -ms-user-select: none; /* Internet Explorer/Edge */
    user-select: none; /* Non-prefixed version, currently supported by Chrome, Edge, Opera and Firefox */
}
.interest-item.selected {
    background: #ec550e;
}
.modal-header{
    border-bottom: none;
}
.modal-footer {
    border-top: none;
}
@media (min-width: 576px) {
    .modal-dialog {
        max-width: 60%;
        margin: 1.75rem auto;
    }
}
.modal-dialog.desktop {
    top: 10%;
}
.modal-dialog.mobile {
    position: absolute;
    bottom: 0;
}
</style>
